export const WICKET_TOKEN_DATA_KEY = 'wicketTokenData';

export const WICKET_TOKEN_KEY = 'wicketToken';

export const WICKET_REFRESH_TOKEN_KEY = 'wicketRefreshToken';

export const WICKET_CODE_VERIFIER_KEY = 'wicketCodeVerifier';

export const WICKET_REDIRECT_URI = 'wicketRedirectURI';

export const VIDEO_CLOSED_TIME = 'videoClosedTime';

export const PREFFERED_LANGUAGE = 'preferedLanguage';
